import { GetRequest, PostRequest } from "../service";

const ControllerName = 'OrderConversation'

/////////////////////////////////////////////////////////////

export const GetHopsitalOrderMessages = (hospitalHospitalOrderId) => 
     GetRequest(`${ControllerName}/hospital-order/${hospitalOrderId}`)

export const SendHopsitalOrderMessage = (hospitalOrderId ,requestBody)  => 
    PostRequest(`${ControllerName}/hospital-order/${hospitalOrderId}`, requestBody)

export const MarkHopsitalOrderMessagesAsRead = (hospitalOrderId)  => 
     PostRequest(`${ControllerName}/hospital-order/mark-as-read/${hospitalOrderId}`)

export const GetHopsitalOrderUnreadCount = (hospitalOrderId)  => 
     PostRequest(`${ControllerName}/hospital-order/unread-count/${hospitalOrderId}`)

/////////////////////////////////////////////////////////////

export const SendBrokerMessage = (medicalOrderId ,requestBody)  => 
    PostRequest(`${ControllerName}/medical-order/${medicalOrderId}`, requestBody)

export const GetBrokerMessages = (medicalOrderId ,bp)  => 
    GetRequest(`${ControllerName}/medical-order/${medicalOrderId}`, bp)

export const MarkBrokerMessagesAsRead = (medicalOrderId)  => 
    PostRequest(`${ControllerName}/medical-order/mark-as-read/${medicalOrderId}`)

export const GetBrokerUnreadCount = (medicalOrderId)  => 
    GetRequest(`${ControllerName}/medical-order/unread-count/${medicalOrderId}`)

/////////////////////////////////////////////////////////////